import React from 'react';
import default_okta_error from '../../assets/images/unassignedAppsError.png';
import './style.scss';
const DefaultOktaError = () => {
  return /*#__PURE__*/React.createElement("div", {
    className: "container"
  }, /*#__PURE__*/React.createElement("img", {
    alt: "Default okta error",
    src: default_okta_error
  }), /*#__PURE__*/React.createElement("div", {
    className: "subHeading"
  }, __('Oops! We have encountered an unknown error.')), /*#__PURE__*/React.createElement("div", {
    className: "subHeading"
  }, __('Please reach'), " ", /*#__PURE__*/React.createElement("a", {
    href: "mailto:TAP_Support@tekion.com"
  }, "TAP_Support@tekion.com"), " ", __(' for resolution.')));
};
export default DefaultOktaError;